import { fetchGraph2 } from './fetch-graph'

export const fetchMetrics = board => async (dispatch, _) => {
  const graphQuery = [
    {
      '@board/metrics': {}
    }
  ]
  const res = await dispatch(fetchGraph2(null, graphQuery, board[':db/id']))
  return res
}
